import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-view-transaction',
  templateUrl: './view-transaction.component.html',
  styleUrls: ['./view-transaction.component.css']
})
export class ViewTransactionComponent implements OnInit {

  jsonData: any;
  transactions: any[];

  constructor(public dialogRef: MdDialogRef<any>) { }

  ngOnInit() {
    if (this.jsonData && this.jsonData.jsonData && this.jsonData.jsonData.transactions) {
      this.transactions = this.jsonData.jsonData.transactions;
    } else {
      this.transactions = [];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/finance/view-transaction/view-transaction.component.ts